import { Component } from 'react';
import { trackFormError } from 'Utils/Analytics';

import './Field.css';

const excludedErrors = [];

class Field extends Component {
  componentDidMount() {
    this.trackError();
  }

  componentDidUpdate() {
    const { meta, fieldTouched } = this.props;
    this.trackError();
    if (fieldTouched && meta.touched) {
      fieldTouched(true);
    }
  }

  trackError() {
    const { meta, pageStartSource, pagePlanFlowType } = this.props;
    if (meta) {
      const { error, touched, active, form: formName } = meta;
      if (error && excludedErrors.indexOf(error) === -1 && touched && !active) {
        trackFormError(
          formName,
          {
            status: 1000,
            message: error,
          },
          {
            page_start_source: pageStartSource || 'other',
            page_plan_flow_type: pagePlanFlowType || undefined,
          }
        );
      }
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default Field;
